import { useQuery } from "@tanstack/react-query";
import { programService } from "@/services/program.service";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "react-feather";

export default function CustomDiscounts() {
  const navigate = useNavigate();
  const { data, isLoading, isError, isFetching } = useQuery({
    queryKey: ["my-custom-programs"],
    queryFn: () => programService.getMyCustomPrograms(),
  });

  return (
    <div className="p-4">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-6">
        <Button variant="outline" onClick={() => navigate(-1)} className="inline-flex items-center  bg-brand-600 hover:bg-brand-700 text-white">
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back
        </Button>
        <h1 className="text-2xl font-semibold">Custom discounts</h1>
        </div>
        <Button onClick={() => navigate("/brand/programs/create")} className="bg-foreground hover:bg-foreground/90 text-background">
          Create program
        </Button>
      </div>

      {(isLoading || isFetching) && (
        <div className="space-y-3 animate-pulse">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="border rounded-md p-4 flex items-center justify-between">
              <div className="w-56 h-4 bg-muted rounded" />
              <div className="w-32 h-9 bg-muted rounded" />
            </div>
          ))}
        </div>
      )}
      {isError && <div className="text-red-500 dark:text-red-400">Failed to load programs</div>}

      {!isLoading && !isError && !isFetching && (
        <div className="space-y-3">
          {(!data || data.length === 0) && (
            <div className="border rounded-md p-6 text-center text-muted-foreground">No custom programs yet. Click Create program to get started.</div>
          )}
          {data?.map((program: any) => (
            <div key={program.id} className="border rounded-md p-4 flex items-center justify-between">
              <div>
                <div className="font-medium">{program.joinTitle || "Custom Program"}</div>
                <div className="text-sm text-muted-foreground">Commission: {Number(program.commissionValue)}% · Discount: {Number(program.discountValue)}%</div>
              </div>
              <Button variant="outline" className="bg-brand-600 hover:bg-brand-700 text-white" onClick={() => navigate(`/brand/programs/${program.id}`)}>
                Manage affiliates
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}


